<template>

    <div class="login">
      <div class="login_form">
        <!-- <el-divider /> -->
        <p>{{SectionTitle}}</p>
       
            <el-form
                :model="loginForm"
                :rules="rules"
                ref="loginForm">
  
            
            
              <el-form-item label="" prop="account" class="elItem">
                <el-input
                    type="text"
                    autocomplete="off"
                    v-model="loginForm.account"
                    placeholder="请输入用户名"
                >
                <template #prefix>
          <el-icon class="el-input__icon"><User /></el-icon>
            </template>
            </el-input>
              </el-form-item>


              <el-form-item label="" prop="password">
                <el-input
                    type="password"
                    autocomplete="off"
                    v-model="loginForm.password"
                    placeholder="请输入密码"
                >
                <template #prefix>
          <el-icon class="el-input__icon"><Lock/></el-icon>
            </template>
            </el-input>
              </el-form-item>


              <el-form-item class="btns">
           
                <!-- <el-button @click="resetLoginForm">重置</el-button> -->
                
              </el-form-item>
              <el-button type="primary" @click="goToLogin" :style="{ width: '400px',height:'35px' }" >登录</el-button>    
              <div class="btnclass" > </div>
              <el-button link @click="btnclick001" style="margin-left:0px;margin-top:-10px" >注册账户</el-button>
              <el-button link @click="btnclick002" style="margin-left:250px;margin-top:-10px">找回密码</el-button>
             
              
            </el-form>
            
         
         
      </div>
    </div>
  </template>
  
  <script>
  //引入注册组件
  import Register from '@/components/register';
  import { ref } from 'vue'
  import { Calendar, Search,User,Lock } from '@element-plus/icons-vue'

  export default {
    data() {
      var validateAccount = (rule, value, callback) => {
        if (value === "") {
          return callback(new Error("账号不能为空"));
        } else if (value === "admin") {
          callback();
        } else {
          callback(new Error("请输入正确的用户名"));
        }
      };
      var validatePassword = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入密码"));
        } else if (value === "123456") {
          callback();
        } else {
          callback(new Error("请输入正确的密码"));
        }
      };
      return {
        loginForm: {
          account: "",
          password: "",
        },
        activeName:'first',//默认显示登录页面
        rules: {
          account: [
            {
              validator: validateAccount,
              trigger: "blur",
            },
          ],
          password: [
            {
              validator: validatePassword,
              trigger: "blur",
            },
          ],
        },
        SectionTitle:'用户登录'
      };
    },
    methods: {
  //固定的账户密码判断实现简单的登录跳转功能，只能测试用
      goToLogin() {
        this.$refs["loginForm"].validate((valid) => {
          if (valid) {
            if (
                this.loginForm.account != "admin" ||
                this.loginForm.password != "123456"
            ) {
              this.$message.error("账号密码不正确");
              return false;
            } else {
              this.$message({ message: "登陆成功", type: "success" });
              this.$router.push("/home");
            }
          } else {
            this.$message.error("登陆失败");
            return false;
          }
        });
      },
      resetLoginForm() {
        this.$refs["loginForm"].resetFields();
      },
      handleClick(){},
      tabChange(name){
        console.log('112',name);
        if(name=='first'){
          this.SectionTitle='用户登录';
        }else{
          this.SectionTitle='用户注册';
        }
      },
      btnclick001(){

        //this.activeName='second';
        this.$router.push('/register') //路由 下方弃用
        this.$emit("add",'register2'); //触发事件
      },
      btnclick002(){
  
      },
      getCheckboxRecords(cb){
        console.log('废弃');
  },
  addone(text){
    //this.activeName='second';
    console.log('啊啊啊',text);
    
    this.activeName=text;
    },
    },
    components:{
      Register,
      ref,
      Calendar,
      Search,
      User,
      Lock
    }
  };
  </script>
  
  <style scoped lang='less'>
  .login {
   // width: 100%;
   // height: 100vh;
  
   // background-image: url("../assets/login/A02.jpg");//背景图
   // background-size: 100% 100vh;
   // background-size: 500px 500px;
   /*  background-position: center center;
    overflow: auto;
    position: relative; */
    .login_form {
      width: 400px;
      height: 300px;
      position: absolute;
      left: 50%;
      top: 40%;
      margin-left: -200px;
      margin-top: -150px;
      padding: 10px;
      background: #fff;
      border-radius: 3px;
      box-shadow: 0 0 10px #ddd;
      .btns {
        display: flex;
        justify-content: flex-end;
      }
    }
    p {
      font-size: 24px;
      text-align: center;
      font-weight: 500;
      color: rgb(27, 146, 175);
    }
    .btnclass{
      margin-left: 200px;
      margin-top:50px;
    }
  }
  .el-row {
      margin-bottom: 20px;
    }
    .el-row:last-child {
      margin-bottom: 0;
    }
    .el-col {
      border-radius: 4px;
    }
    
    .grid-content {
      border-radius: 4px;
      min-height: 36px;
    }
  </style>
  
